import Link from "@/lib/next-shim";
import { Card, LinkButton } from "@/components/ui";
import { getDict } from "@/lib/i18n";

// Passwords are reset only by the person who manages the account (people.go, admin.go):
// a client by their gym's coaches, a coach by the head coach, a head coach by a sysadmin.
// So "forgot password" explains whom to contact; there is no self-service reset.
export function ForgotPasswordPage() {
  const t = getDict("vi");
  const who = [
    { title: t.forgotClientTitle, body: t.forgotClientBody },
    { title: t.forgotCoachTitle, body: t.forgotCoachBody },
    { title: t.forgotHeadCoachTitle, body: t.forgotHeadCoachBody },
  ];
  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-6 py-10">
      <div className="mb-6 text-center">
        <Link href="/login">
          <img src="/icon.svg" alt="" className="mx-auto mb-4 h-12 w-12" />
        </Link>
        <h1 className="text-2xl font-bold">{t.forgotPasswordTitle}</h1>
      </div>
      <p className="mb-4 text-sm text-muted">{t.forgotPasswordIntro}</p>
      <div className="space-y-2">
        {who.map((w) => (
          <Card key={w.title} className="py-3">
            <p className="font-medium">{w.title}</p>
            <p className="mt-0.5 text-sm text-muted">{w.body}</p>
          </Card>
        ))}
      </div>
      <p className="mt-4 text-sm text-muted">{t.forgotPasswordAfter}</p>
      <LinkButton href="/login" variant="secondary" className="mt-6 w-full">
        {t.backToLogin}
      </LinkButton>
    </main>
  );
}
